import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { cityCurrencyType } from 'src/app/api/interfaces/city.interface';
import {
  IBalances,
  specialityType,
} from 'src/app/api/interfaces/configuration.interface';
import { IComleteSlot } from 'src/app/api/interfaces/pub.interface';

@Injectable({
  providedIn: 'root',
})
export class MapModalService {
  public currentModalType:
    | 'exploration'
    | 'acquisition'
    | 'close'
    | 'buyLandInfo'
    | 'buyLandConfirm'
    | 'buildCityInfo'
    | 'buildCityConfirm'
    | 'hiringCharacter'
    | 'admin'
    | 'accelerator'
    | 'characterSelectGrid'
    | 'energyRestoring'
    | 'xpBoost'
    | 'homeCharacterSelect'
    | 'welcome'
    | 'tutorial-complete'
    | 'pub-results'
    | 'openSlot' = 'close';

  public openSlotInfo: IComleteSlot | undefined;
  public pickedSlot: IComleteSlot | undefined;
  public isCraftingBuilding: boolean = true;
  public characterSlotId: BehaviorSubject<number | undefined> =
    new BehaviorSubject<number | undefined>(undefined);

  public pickedCharacterSpeciality: BehaviorSubject<
    specialityType | undefined
  > = new BehaviorSubject<specialityType | undefined>('FARMER');
  public openLandCoords:
    | {
        coordinateX: number;
        coordinateY: number;
      }
    | undefined;

  constructor() {}

  public getBalanceAccount(
    balances: IBalances[],
    type: cityCurrencyType
  ): number | undefined {
    return balances.find((balance) => balance.currency === type)?.quantity;
  }

  public calculateCardCount(
    cardValue: number,
    userCardQuantity: number,
    remainder: number
  ): { count: number; restoreValue: number } {
    const count = remainder / cardValue;
    const roundedCount = Math.floor(count);
    if (userCardQuantity > 0 && remainder > 0) {
      if (count < 1) {
        return { count: 1, restoreValue: Math.round(remainder) };
      } else {
        if (userCardQuantity >= roundedCount) {
          return {
            count: roundedCount,
            restoreValue: Math.round(roundedCount * cardValue),
          };
        } else {
          return {
            count: userCardQuantity,
            restoreValue: Math.round(userCardQuantity * cardValue),
          };
        }
      }
    } else {
      return { count: 0, restoreValue: cardValue };
    }
  }
}
